import React from "react";
import { useState } from "react";
import WithdrawCard from "../../components/shared/withdrawui/WithdrawCard";
import { StyledTabs, StyledTab } from "../../components/ui/Tabs";
import { Box } from "@mui/material";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import Personal from "./Personal";
import Business from "./Business";
import Bank from "./Bank";
import Marketplace from "./Marketplace";

export default function Configure() {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <WithdrawCard />
      <br></br>
      <Box sx={{ width: "100%" }}>
        <TabContext value={value}>
          <Box>
            <StyledTabs
              value={value}
              onChange={handleChange}
              aria-label="scrollable auto tabs example"
              allowScrollButtonsMobile
              scrollButtons
              variant="scrollable"
            >
              <StyledTab label="Personal Information" value="1" />
              <StyledTab label="Business Information" value="2" />
              <StyledTab label="Bank Details" value="3" />
              <StyledTab label="Marketplace connections" value="4" />
            </StyledTabs>
            <Box sx={{ p: 1 }} />
          </Box>
          <TabPanel value="1" sx={{ padding: 1 }}>
            <Personal />
          </TabPanel>
          <TabPanel value="2" sx={{ padding: 1 }}>
            <Business />
          </TabPanel>
          <TabPanel value="3" sx={{ padding: 1 }}>
            <Bank />
          </TabPanel>
          <TabPanel value="4" sx={{ padding: 1 }}>
            <Marketplace />
          </TabPanel>
        </TabContext>
      </Box>
    </div>
  );
}
